<template>
  <div>
    <v-card>
      <v-card-title class="card-title-prerequisites">
        <v-icon color="#41916b" large class="card-title-prerequisites__icon">
          mdi-chevron-double-right
        </v-icon>
        {{ $t('titles.pme_pre_requisits') }}
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="sendData" ref="form" :disabled="disableForm">
          <v-row dense>
            <v-col cols="12" sm="6" class="py-1">
              <v-radio-group
                data-cy="radio-lesao"
                dense
                :rules="formRules"
                v-model="deathData.lesao_encefalica_irreversivel"
              >
                <label class="field-label">
                  {{ labels.lesao }}<span class="required">*</span>
                </label>
                <v-radio
                  dense
                  :label="$t('options.yes')"
                  value="SIM"
                  color="#086318"
                  class="mr-2"
                />
                <v-radio dense :label="$t('options.not')" value="NÃO" color="#086318" />  
              </v-radio-group>
            </v-col>

            <v-col cols="12" sm="6" class="py-1">
              <v-radio-group
               data-cy="radio-causas"
                dense
                :rules="formRules"
                v-model="deathData.ausencia_causas_trataveis"
              >
                <label class="field-label">{{ labels.causas}}<span class="required">*</span></label
                >
                <v-radio
                  dense
                  :label="$t('options.yes')"
                  value="SIM"
                  color="#086318"
                  class="mr-2"
                />
                <v-radio dense :label="$t('options.not')" value="NÃO" color="#086318" /> 
              </v-radio-group>
            </v-col>

            <v-col cols="12" sm="6" class="py-1">
              <v-radio-group
                data-cy="radio-tratamento"
                dense
                :rules="formRules"
                v-model="deathData.trat_obs_hosp_ehi_6h_24h"
              >
                <label class="field-label">{{ labels.tratamento }}<span class="required">*</span></label
                >
                <v-radio
                  dense
                  :label="$t('options.yes')"
                  value="SIM"
                  color="#086318"
                  class="mr-2"
                />
                <v-radio dense :label="$t('options.not')" value="NÃO" color="#086318" /> 
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" class="py-1">
              <v-radio-group
                data-cy="radio-parametros"
                dense
                :rules="formRules"
                v-model="deathData.parametros_hemodinamicos_ok"
              >
                <label class="field-label">{{ labels.parametros }}<span class="required">*</span></label
                >
                <v-radio
                  dense
                  :label="$t('options.yes')"
                  value="SIM"
                  color="#086318"
                  class="mr-2"
                />
                <v-radio dense :label="$t('options.not')" value="NÃO" color="#086318" /> 
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="6" class="py-1">
              <v-radio-group
                data-cy="radio-hipotermia"
                dense
                :rules="formRules"
                v-model="deathData.ausencia_hipotermia"
              >
                <label class="field-label"
                  >{{ labels.hipotermia}}<span class="required"
                    >*</span
                  ></label
                >
                <v-radio
                  dense
                  :label="$t('options.yes')"
                  value="SIM"
                  color="#086318"
                  class="mr-2"
                />
                <v-radio dense :label="$t('options.not')" value="NÃO" color="#086318" />
              </v-radio-group>
            </v-col>

            <v-col cols="12" sm="6" class="py-1">
              <v-radio-group
                data-cy="radio-depressores"
                dense
                :rules="formRules"
                v-model="deathData.ausencia_depressores_snc"
              >
                <label class="field-label"
                  >{{ labels.depressores }}<span class="required">*</span></label
                >
                <v-radio
                  dense
                  :label="$t('options.yes')"
                  value="SIM"
                  color="#086318"
                  class="mr-2"
                />
                <v-radio dense :label="$t('options.not')" value="NÃO" color="#086318" /> 
              </v-radio-group>
            </v-col>
          </v-row> 
          <v-row dense no-gutters> 
            <v-col cols="12" sm="3" class="py-1">
              <v-autocomplete
                data-cy="input-crm"
                dense
                outlined
                class="rounded-lg"
                :items="professional_doctors"
                item-text="crm"
                item-value="id"
                @input="changeCRM"
                v-model="crm"
                color="#086318"
              >
                <template v-slot:label> CRM </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="9" class="py-1">
              <v-text-field
              data-cy="input-medico"
                dense
                outlined
                class="rounded-lg"
                disabled
                v-model="deathData.professional_doctor_name"
                label="Nome do Médico"
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-row dense class="d-flex justify-center">
              <v-btn
                class="rounded-lg mr-1"
                text
                outlined
                color="#41916b"
                @click="closeModal()"
                dark
              >
                {{ disableForm == true ? "FECHAR" : "CANCELAR" }}
              </v-btn>

              <v-btn
                v-if="disableForm == true"
                class="rounded-lg mr-1" 
                color="#41916b"
                @click="disableForm = false"
                dark
              >
                {{$t('buttons.edit')}}
              </v-btn>

              <v-btn
                data-cy="btn-sendData"
                v-if="disableForm == false"
                class="rounded-lg save-btn"
                color="#41916b"
                dark
                :loading="loading"
                @click="sendData()"
              >
                {{$t('buttons.save')}}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card> 

    <v-dialog v-model="doctorDialog" width="500px" persistent>
      <v-card class="rounded-lg pa-4">
        <Doctors
          :resource="{}"
          @closeGlasgowDialog="closeDialog($event)"
          @closeDialog="closeDialog($event)"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import Doctors from "@/components/doctors/Doctors.vue";
import { mapActions, mapGetters } from "vuex";
import dateTimeLimit from "@/utils/dateTimeLimit";
import currentUser from "@/utils/currentUser";
export default {
  data() {
    return {
      dialog: false, 
      snackbar: false,
      deathData: {},
      message: "",
      formRules: [(v) => !!v || "Este campo é obrigatório"], 
      loading: false,
      professional_doctors: [],
      crm: "",
      doctorDialog: false,
      disableForm: false,
      labels: {
        lesao: "Presença de lesão encefálica de causa conhecida, irreversível e capaz de causar a morte encefálica?",
        causas: "Ausência de causas tratáveis que possam confundir o diagnóstico de morte encefálica?",
        tratamento: "Tratamento e observação hospitalar ≥ 6h ou ≥ 24h em casos de encefalopatia hipóxico-isquemica?",
        parametros: "SatO2 > 94% e PAS ≥ 100mmHg ou PAM ≥ 65mmHg ou pela faixa etária (menor que 16 anos)?",
        hipotermia: "Ausência de Hipotermia (T>35,0°C)?",
        depressores: "Ausência de uso de Fármacos Depressores do SNC ou Bloqueadores musculares?"
      }
    };
  },

  props: {
    donorId: Number,
    glasgowId: Number,
    glasgowDescription: String,
    avNeurologica: Object,
  },

  components: {
    Doctors,
  },

  computed: {
    ...mapGetters({
      resource: "getPatientData",
    }),

    currentUser(){
      return currentUser.getUserData()
    },

    maxDate() {
      const now = new Date()
      return now.toISOString().slice(0, 10)
    } 
  },

  watch: {
    'avNeurologica': {
      async handler(item) { 
        if(!item.id){
          this.resetForm();
        }  

        let prerequisite = item.pme_prerequisites[0];

        if(!prerequisite) return;

        await this.prepareDoctors(); 

        this.fillForm(prerequisite); 
      },
      immediate: true,
    },
  },

  async created() {
    await this.getDoctors();
  },

  methods: {
    ...mapActions(["changeDonorId", "changeSnackBarData"]),

    resetFormState() { 
      this.deathData = {};
      this.crm = "";
      this.disableForm = false;
      this.$refs.form.resetValidation();
    },

    async prepareDoctors() {
      if(!this.professional_doctors.length) {
        await this.getDoctors();
      }
    },

    fillForm(data) { 
      this.deathData = data;
      this.crm = parseInt(data.professional_doctor_id);

      this.changeDoctorData();  

      this.disableForm = true;
    },

    changeDoctorData() { 
      const doctor = this.professional_doctors.find(
        (doctor_item) => doctor_item.id == this.crm
      );

      if(doctor) {
        this.deathData.professional_doctor_id = doctor.id;
        this.deathData.professional_doctor_name = doctor.name;
      }
    },

    onlyDateInput(path,field, value) {  
       this[path][field] =
        dateTimeLimit.limiteInputOnlyDate(value)
    },
    getDoctors() {
      return axios.get(`/professional_doctors`).then((response) => {
        this.professional_doctors = [
          {
            id: "001",
            name: "Outro",
            crm: "...Outro",
          },
          ...response.data,
        ];
      });
    },

    closeModal() {
      this.$emit("fechar");
      this.resetFormState();
    },

    sendData() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        let data = this.deathData;
            data.donor_id = this.donorId;
            data.glasgow_scale_id = this.glasgowId;
            data.user_id = this.currentUser.id; 
 
        axios({
              method: this.deathData.id ? 'PUT' : 'POST',
              url: this.deathData.id ? `/pme_prerequisites/${this.deathData.id}` : `/pme_prerequisites`,
              data: data,
            }).then((response) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });
            this.dialog = false;
            this.crm = "";
            this.deathData = {};
            this.$refs.form.resetValidation();
            this.$emit("fechar");
 
            setTimeout(() => {
              this.changeDonorId(this.donorId);
              this.closeSnackBar();
            }, 1000);
          })
          .catch((err) => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: "Algo deu errado!",
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });
            this.$emit("fechar");
            this.$emit("nextTab");
            err;
            var error = "";
            Object.values(this.$store.state.errorMessage).map((value) => {
              error = value;
            });
            this.displayError.message = error.toString();
            this.displayError.display = true;
            setTimeout(() => {
              this.closeSnackBar();
              this.displayError.display = false;
            }, 3000);
          });
      }
    }, 

    changeCRM() {
      if(this.crm == "001") {
        this.doctorDialog = true;

        return;
      }

      this.changeDoctorData();
    },

    formatDate(dateStr) {
      const [day, month, year] = dateStr.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    closeDialog(item) {
      this.crm = item?.id || item;
      this.changeCRM();
      this.getDoctors();
      this.doctorDialog = false;
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>

<style scoped>
.field-label {
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 4px;
  display: block;
}

.required {
  color: red;
  margin-left: 2px;
}

.v-radio-group {
  margin-top: 0 !important;
}

.v-radio {
  display: block;
  margin-bottom: 4px;
  margin-top: 0 !important;
}

.v-radio .v-input--selection-controls__ripple {
  display: none; /* Remove ripple para deixar mais clean */
}

.cancel-btn {
  background-color: #7b8a81;
  color: white;
}

.save-btn {
  background-color: #41916b;
  color: white;
}

/* Remove espaçamento padrão do v-row */
.v-row {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
 
.v-col.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
 
.v-radio .v-label {
  font-size: 0.9rem;
  line-height: 1.1;
  margin-left: 4px;
}

.card-title-prerequisites {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-x: auto;
}

.card-title-prerequisites__icon {
  margin-right: 4px;
}
</style>
